import { $authHost } from ".."

// export const checkPackAPI = async ({ keyCrmOrderNumber }) => {
//     const {data} = await $authHost.post('api/pack/check', {keyCrmOrderNumber})
//     return data
// }

export const editSeriesAPI = async (series) => {
    const {data} = await $authHost.post(`api/serieses/${series.id}`, series)
    return data
}

export const addSeriesesInPackAPI = async ({ packId, goodTypeId, goodId }) => {
    const {data} = await $authHost.post(`api/serieses/in_pack/${packId}`, { goodTypeId, goodId })
    return data
}

// Додавання товару в коробку через фронтент (без сканера)
export const addGoodInBoxAPI = async ({ boxId, goodTypeId, goodId }) => {
    const {data} = await $authHost.post(`api/serieses/in_box/${boxId}`, { goodTypeId, goodId })
    return data
}

export const getSeriesesInBoxAPI = async ({ boxId, goodId, offset, limit, query }) => {

    let params = `?boxId=${boxId}`
    if (query) {
        params += `&query=${query}`
    } else if ((offset || offset === 0) && limit) {
        params += `&offset=${offset}&limit=${limit}`
    }
    if (goodId) {
        params += `&goodId=${goodId}`
    }

    const {data} = await $authHost.get(`api/serieses/box/${params}`)
    return data
}

export const getGoodBySeriesAPI = async ({ goodSeries }) => {
    // const {data} = await $authHost.get(`api/serieses/good_by_series/${goodSeries}`)
    const {data} = await $authHost.post(`api/serieses/good_by_series/get_good`, {goodSeries})
    return data
}

// Додавання товару в коробку сканером
export const addGoodNewInBoxAPI = async (seriesNew) => {
    const {data} = await $authHost.post(`api/serieses/good_by_series/add_in_box/`, seriesNew)
    return data
}

export const getSeriesQrCodeAPI = async ({ seriesId, type }) => {
    let params = ''

    if (type) {
        params = `?type=${type}`
    }

    const {data} = await $authHost.get(`api/serieses/qr_codes/${seriesId}${params}`)
    return data
}

// Перевірка відсканованого товару в коробці
export const getSeriesGoodDataBySeriesScanAPI = async ({ goodType, scanData, goodsFromBd }) => {
    const {data} = await $authHost.post(`api/serieses/good_by_series/check_in_box/`, { goodType, scanData, goodsFromBd })
    return data
}

// Перевірка відсканованого товару в коробці (для співробітника ВТК)
export const getSeriesGoodDataBySeriesScanForVtkAPI = async ({ scanData }) => {
    const {data} = await $authHost.post(`api/serieses/good_by_series/check_in_box_vtk/`, { scanData })
    return data
}

export const packingBoxInPackByScanAPI = async ({ goodsFromBd }) => {
    const {data} = await $authHost.post(`api/serieses/good_by_series/packing_in_box/`, { goodsFromBd })
    return data
}

export const packingBoxInPackByScanConfirmAPI = async ({ dataForConfirm }) => {
    const {data} = await $authHost.post(`api/serieses/good_by_series/packing_in_box_vtk/`, dataForConfirm)
    return data
}

export const getChangesSeriesesAPI = async ({ seriesId }) => {
    const {data} = await $authHost.get(`api/serieses/changes/${seriesId}`)
    return data
}